export const DEFAULT_MODAL_WIDTH = '532px';
